import { formatTime } from '@nile/mangifera/src/Pebbles/Calendar';
import { SVGIcon } from '@superops/super-icons';
import { TextStyle } from '@superops/ui-design-system';
import { getTranslatedText } from '@nile/components';
import React from 'react';
import { useIntl } from 'react-intl';

const TextContainer = ({ title, content, titleWeight, flex }) => {
  const formattedTime = formatTime(content);
  return (
    <div className={`${flex ? 'flex g5' : 'mb10'}`}>
      {title && (
        <div className="mb10">
          <TextStyle weight={titleWeight || 'Medium'}>{title}: </TextStyle>
        </div>
      )}

      <div>
        <TextStyle>{formattedTime?.displayValue || '0h'}</TextStyle>
      </div>
    </div>
  );
};

const TicketWorklogSummary = (props) => {
  const { data, content } = props;
  const intl = useIntl();
  return (
    <div className="text-white">
      <div className="mb-10 flex g10">
        <div className="flex">
          <SVGIcon name={data?.headingIcon} />
        </div>

        <div className="text-white">
          <TextStyle weight="medium">{data?.headingText}</TextStyle>
        </div>
      </div>

      <div className="ai-content-container-max-height scroll">
        {content?.summaryPoints && (
          <ul className="pl20">
            {content?.summaryPoints?.map((points) => {
              return (
                <li className="mb-5">
                  <div className="text-white">
                    <TextStyle>{points}</TextStyle>
                  </div>
                </li>
              );
            })}
          </ul>
        )}
        <div className="mt20">
          {content?.recordedTime && (
            <TextContainer
              title={getTranslatedText(
                intl,
                'ticket.details.worklog.totalTimeSpent'
              )}
              content={content?.totalTime}
              flex
            />
          )}

          {content?.recordedTime && (
            <TextContainer
              title={getTranslatedText(intl, 'attribute.worklog.recordedTime')}
              content={content?.recordedTime}
              flex
            />
          )}

          {content?.timeTaken && (
            <TextContainer title="Timer" content={content?.timeTaken} flex />
          )}
        </div>
      </div>
    </div>
  );
};

export default TicketWorklogSummary;
